module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/47125398f6f5e43b933593236a9d8b9a.png";